import React from "react";
import { Badge } from "react-bootstrap";
import { LocalizedObject, ExpressionArg,  } from "survey-engine/data_types";
import { isLocalizedString, isExpressionArg } from "../../utils";
import { ExpressionPreviewArgComponent } from "ifn-expression-editor";

interface LocalizedCompProps {
    contents: LocalizedObject[];
    label?:string 
    languages: Array<string> // List of languages to show, if empty all will be shown
}

type PartsTypes = ExpressionArg | string | number;

/**
 * Show a localized Component
 * @param props 
 * 
 * @returns 
 */
export const LocalizedComponent : React.FC<LocalizedCompProps> = (props) =>{
    
    const filter : (v:LocalizedObject)=>boolean = props.languages.length > 0 ? (v:LocalizedObject)=> { return props.languages.includes(v.code) } : (v)=> true;

    const contents = props.contents ? props.contents.filter(filter) : [];
    
    if(!contents) {
        return <Badge bg="dark">Empty</Badge>
    }
    
    const part = (p: PartsTypes, index:number) => {
        if(isExpressionArg(p)) {
            const e = p as ExpressionArg;
            return <ExpressionPreviewArgComponent key={index} exp={e}/>;
        }
        const e = '' + p;
        return <span key={index}>{e}</span>;
    }

    const localize = (loc: LocalizedObject, index:number) => {
        return (
        <li className="localized-object" key={index}>
            <Badge bg="secondary" className="">{loc.code}</Badge>
            <span className="localized-parts">
               { isLocalizedString(loc) ? loc.parts.map(part) : ''}
            </span>
        </li>
        );
    }

    return <ul className="localized-list border">
        { contents.map(localize) }
    </ul>;

 };
 